module.exports = __webpack_public_path__ + "static/investors-info4-9a73bdbfd2778fcbba2161b82c73a737.jpg";